<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <div class="titleh1"><code />运单信息</div>
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="运单号">
              <el-input
                v-model="form.orderCode"
                placeholder="请输入内容"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <el-form-item label="托运人名称">
            <el-input v-model="form.shipmentName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="托运人电话">
            <el-input v-model="form.shipmentPhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实际承运人姓名">
            <el-input v-model="form.driverName" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实际承运人电话">
            <el-input v-model="form.driverPhone" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号">
            <el-input v-model="form.vehicleLicense" :disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="成交单价">
              <el-input
                v-model="form.taxPrice"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append">{{ form.isTrunkName }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="承运单价">
              <el-input
                v-model="form.realPrice"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append">{{ form.isTrunkName }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="货物单价">
              <el-input
                v-model="form.coalPrice"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append">{{
                  "元/" + form.coalUnitName
                }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="装货吨数" prop="loadQuantity">
              <el-input
                v-model="form.loadQuantity"
                placeholder="请输入内容"
                :disabled="step != 1"
                @input="
                  value =>
                    form.coalUnitName == '件'
                      ? formFormatter.isInteger(
                          value,
                          oldValue,
                          form,
                          'loadQuantity'
                        )
                      : formFormatter.isFloor3(
                          value,
                          oldValue,
                          form,
                          'loadQuantity'
                        )
                "
              >
                <template slot="append">{{ form.coalUnitName }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="卸货吨数" prop="unloadQuantity">
              <el-input
                v-model="form.unloadQuantity"
                placeholder="请输入内容"
                :disabled="step != 1"
                @input="
                  value =>
                    form.coalUnitName == '件'
                      ? formFormatter.isInteger(
                          value,
                          oldValue,
                          form,
                          'unloadQuantity'
                        )
                      : formFormatter.isFloor3(
                          value,
                          oldValue,
                          form,
                          'unloadQuantity'
                        )
                "
              >
                <template slot="append">{{ form.coalUnitName }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="结算吨位" prop="settlementWeight">
              <el-input
                v-model="form.settlementWeight"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append">{{ form.coalUnitName }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="合理路耗">
              <template v-if="form.canWastage == -1">
                不计
              </template>
              <template v-else>
                <el-input
                  v-model="form.canWastage"
                  placeholder="请输入内容"
                  :disabled="true"
                >
                  <template slot="append">{{ form.coalUnitName }}</template>
                </el-input>
              </template>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="实际路耗">
              <el-input
                v-model="form.wastage"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append">{{ form.coalUnitName }}</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="异常费用" prop="abnormalFee">
              <el-input
                v-model="form.abnormalFee"
                placeholder="请输入内容"
                :disabled="step != 1"
                @input="
                  value =>
                    formFormatter.isFloor2(
                      value,
                      oldValue,
                      form,
                      'abnormalFee',
                      true
                    )
                "
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="其他费用" prop="extraFee">
              <el-input
                v-model="form.extraFee"
                placeholder="请输入内容"
                :readonly="true"
                :disabled="step != 1"
              >
                <div slot="append">
                  <span>元</span>
                  <el-button
                    icon="el-icon-edit"
                    @click="showEditTable = step == 1 ? true : false"
                  />
                </div>
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="里程数">
              <el-input
                v-model="form.distance"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >公里</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <!-- 损耗费用 -->
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="损耗费用">
              <el-input
                v-model="form.wastageFee"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >公里</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <!-- 浮动费用 -->
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="浮动费用">
              <el-input
                v-model="form.driftPrice"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1" style="display: flex;">
        <div><code />实际承运人费用</div>
        <div
          style="margin-left:20px;color:red;"
          v-if="form.calculatePriceStandard"
        >
          <span
            v-if="
              form.calculatePriceStandard &&
                form.deliveryFeePractical > form.calculatePriceStandard
            "
            >运费过高，</span
          >
          最高运费为{{ form.calculatePriceStandard.toFixed(2) || "--" }}元
        </div>
      </div>
      <el-row>
        <!-- <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="预估运费">
              <el-input v-model="form.deliveryFeeDeserved" placeholder="请输入内容" :disabled="true">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col> -->
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="应收运费">
              <el-input
                v-model="form.deliveryFeePractical"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="实收运费">
              <el-input
                v-model="form.driverActualFreight"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="预付金额">
              <el-input
                v-model="form.payAmount"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <!-- 实收现金 -->
            <el-form-item label="到付金额" prop="driverActualCash">
              <el-input
                v-model="form.driverActualCash"
                placeholder="请输入内容"
                :disabled="step != 2"
                @change="setDelivery"
                @input="
                  value =>
                    formFormatter.isFloor2(
                      value,
                      oldValue,
                      form,
                      'driverActualCash'
                    )
                "
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <!-- 合计收款 -->
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="回单付金额">
              <el-input
                v-model="form.returnAmount"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <!-- 合计金额 -->
        <el-col :span="8">
          <div class="grid-content bg-purple-light">
            <el-form-item label="合计金额">
              <el-input
                v-model="form.deliveryCashFee"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />托运人费用</div>
      <el-row>
        <!-- <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="预估运费">
              <el-input v-model="form.taxFee" placeholder="请输入内容" :disabled="true">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
        </el-col> -->
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="应付运费">
              <el-input
                v-model="form.shipmentDeliveryFeePractical"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="实付运费">
              <el-input
                v-model="form.shipmentActualFreight"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="预付金额">
              <el-input
                v-model="form.payAmount"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="到付金额">
              <el-input
                v-model="form.shipperDeliveryFee"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="回单付金额">
              <el-input
                v-model="form.shipmentActualCash"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="到付服务费">
              <el-input
                v-model="form.taxPayFee"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="回单付服务费">
              <el-input
                v-model="form.returnTaxFee"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="总服务费">
              <el-input
                v-model="form.allTaxFee"
                placeholder="请输入内容"
                :disabled="true"
              >
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <!-- 异常费用 -->
      <div class="titleh1"><code />异常信息</div>
      <el-row>
        <el-col :span="8">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="其他费用">
              <el-input v-model="form.abnormalFee" :disabled="true">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="备注">
              <div>
                {{ form.abnormalRemark || "--" }}
              </div>
              <!-- <el-input
                v-model="form.abnormalRemark"
                :disabled="true"
              >
              </el-input> -->
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-dark">
            <el-form-item label="异常图片">
              <template
                v-if="form.abnormalImgList && form.abnormalImgList.length"
              >
                <el-image
                  v-for="(value, index) in form.abnormalImgList"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px;"
                  :src="value"
                  :preview-src-list="form.abnormalImgList"
                >
                </el-image>
              </template>
              <div v-else>--</div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <div class="titleh1"><code />在途信息</div>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="装车位置">
              <el-input
                v-model="form.loadPlace"
                placeholder="请输入内容"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-form-item label="装车图片">
              <div
                v-if="form.loadImgUrls && form.loadImgUrls.length != 0"
                class="demo-image"
              >
                <div
                  v-for="url in loadImgUrls"
                  :key="url"
                  style="display: inline-block; padding: 0 4px 4px 0;"
                >
                  <el-image
                    style="max-width: 100px; height: 100px"
                    :src="url"
                    :preview-src-list="loadImgUrls"
                  />
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-form-item label="卸车位置">
              <el-input
                v-model="form.unloadPlace"
                placeholder="请输入内容"
                :disabled="true"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <el-form-item label="卸货图片">
              <div
                v-if="form.ticketImageUrls && form.ticketImageUrls.length != 0"
                class="demo-image"
              >
                <div
                  v-for="url in ticketImageUrls"
                  :key="url"
                  style="display: inline-block; padding: 0 4px 4px 0;"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="url"
                    :preview-src-list="ticketImageUrls"
                  />
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <!-- 查看轨迹 -->
      <div class="titleh1"><code />查看轨迹</div>
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple-light">
            <img
              @click="uploadClick"
              style="width: 160px; height: 160px;cursor: pointer;margin-bottom:20px;"
              src="@/assets/queueingSystem/summary_web_banner.png"
              alt=""
            />
          </div>
        </el-col>
      </el-row>

      <div class="titleh1">
        <code />申诉记录
        <span style="color: #409EFF;" v-if="authorizeCause"
          >(首次驳回原因：{{ authorizeCause }})</span
        >
      </div>
      <AppealRecord :arr="orderAppealObj"></AppealRecord>

      <!-- <div style="width:100%;text-align:right;">
          <template v-if="step == 2">
            <el-button
              type="primary"
              :disabled="submitDisabled"
              @click="detailsbut('form')"
              >保存</el-button
            >
            <el-button
              type="primary"
              :disabled="submitDisabled"
              @click="detailsSave('form')"
              >核算</el-button
            >
            <el-button
              type="primary"
              :disabled="submitDisabled"
              @click="handleStep(1, 'form')"
              >上一步</el-button
            >
          </template>
          <el-button
            v-if="step == 1"
            type="primary"
            @click="handleStep(2, 'form')"
            >下一步</el-button
          >
          <el-button @click="funcCancel()">取消</el-button>
          <el-button v-if="step == 1" type="primary" @click="handlePass"
            >核算通过</el-button
          >
          <el-button v-if="step == 1" type="danger" @click="funcReject"
            >驳回</el-button
          >
        </div> -->
      <div
        style="width:100%;display: flex;justify-content: space-between;margin-top:40px;margin-bottom:20px;padding-left:20px;padding-right:20px;"
      >
        <div v-if="step == 1">
          <el-button type="primary" @click="handleStep(2, 'form')"
            >下一步</el-button
          >
          <el-button @click="funcCancel()">取消</el-button>
        </div>
        <div v-else></div>
        <div>
          <template v-if="step == 2">
            <el-button
              type="primary"
              :disabled="submitDisabled"
              @click="detailsbut('form')"
              >保存</el-button
            >
            <el-button
              type="primary"
              :disabled="submitDisabled"
              @click="detailsSave('form')"
              >核算</el-button
            >
            <el-button
              type="primary"
              :disabled="submitDisabled"
              @click="handleStep(1, 'form')"
              >上一步</el-button
            >
          </template>
          <el-button v-if="step !== 1" @click="funcCancel()">取消</el-button>
          <!--<el-button
            v-if="step == 1 && showPass"
            type="primary"
            @click="handlePass"
            >核算通过</el-button
          >-->

          <el-button v-if="step == 1" type="danger" @click="funcReject"
            >驳回</el-button
          >
        </div>
      </div>
    </el-form>
    <!-- 其他费用 -->
    <vxe-modal
      v-model="showEditTable"
      title="其他费用"
      width="800"
      height="auto"
      resize
    >
      <el-table ref="xTable" resizable border :data="orderExtraFeeList">
        <el-table-column width="50" type="index" label="序号" />
        <el-table-column width="108" label="费用名称">
          <template v-slot="{ row }">
            <el-select
              ref="extraFeeType"
              v-model="row.extraFeeType"
              placeholder="请选择"
              size="mini"
              @change="
                value => {
                  getExtraFeeType(value, row);
                }
              "
            >
              <el-option
                v-for="(v, k) in extraFeeType"
                :key="k"
                :value="v.code"
                :label="v.name"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="108" prop="extraFeeAmount" label="金额">
          <template v-slot="{ row }">
            <el-input
              v-model="row.extraFeeAmount"
              type="number"
              placeholder="请输入金额"
              @input="
                value =>
                  formFormatter.isFloor2(value, oldValue, row, 'extraFeeAmount')
              "
            />
          </template>
        </el-table-column>
        <el-table-column width="108" label="收支类型">
          <template v-slot="{ row }">
            <el-select
              v-model="row.extraPayType"
              placeholder="请选择"
              size="mini"
            >
              <el-option
                v-for="(v, k) in extraPayType"
                :key="k"
                :value="k"
                :label="v"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="extraFeeRemark" label="备注">
          <template v-slot="{ row, $index }">
            <el-input
              v-model="row.extraFeeRemark"
              maxlength="255"
              @blur="checkLength(row.extraFeeRemark, $index)"
            />
          </template>
        </el-table-column>
        <el-table-column width="50">
          <template v-slot:header>
            <vxe-button type="text" @click="insertEvent(-1)">
              <em class="el-icon-plus" />
            </vxe-button>
          </template>
          <template v-slot="{ row, $index }">
            <vxe-button type="text" @click="delRowEvent(row, $index)">
              <em class="el-icon-minus" />
            </vxe-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px;text-align: right;padding-right: 20px;">
        <el-button @click="backExtraFee">取 消</el-button>
        <el-button type="primary" @click="saveExtraFee">确 定</el-button>
      </div>
    </vxe-modal>
  </div>
</template>
<script>
import AppealRecord from "@/components/AppealRecord/index.vue";
import {
  orderHandleEditSubmit,
  calculateOrderDetail,
  queryOrderAppealList,
  orderHandleEditSubmitAndSave,
  reviewAppeal,
  orderHandlePC
} from "@/api/transport";
import { getListDict } from "@/api/commonApi";
import { isNumber } from "@/utils/validate";
import { mayDecimal } from "@/utils/validate4Form.js";
export default {
  components: {
    AppealRecord
  },
  data() {
    return {
      authorizeCause: "",
      copyForm: null,
      submitDisabled: false,
      showEditTable: false,
      extraFeeType: [],
      extraPayType: { "0": "收入", "1": "支出" },
      form1: {}, // 保存第一步数据
      form: {},
      emptyForm: {
        code: "",
        loadQuantity: "",
        unloadQuantity: "",
        orderCode: "",
        shipperName: "",
        driverActualCash: "",
        extraFee: "",
        orderExtraFeeList: [],
        abnormalFee: "",
        price: "",
        coalPrice: "",
        canWastage: "",
        distance: "",
        vehicleLicense: "",
        driverName: "",
        driverPhone: "",
        loadPlace: "",
        unloadPlace: "",
        shipperDeliveryFee: "",
        payOil: "",
        payAmount: "",
        deliveryFeeDeserved: "",
        deliveryFeePractical: "",
        deliveryOilFee: "",
        gmtModified: ""
      },
      orderExtraFeeList: [],
      rules: {
        driverActualCash: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ],
        abnormalFee: [
          { required: true, message: "请输入", trigger: "blur" },
          { validator: mayDecimal, trigger: "blur" }
        ],
        extraFee: [{ required: true, message: "请输入", trigger: "blur" }],
        unloadQuantity: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        loadQuantity: [{ required: true, message: "请输入", trigger: "blur" }],
        extraFeeAmount: [{ required: true, message: "请输入", trigger: "blur" }]
      },
      preservation: {
        code: "",
        isFirst: 1
      },
      step: 1,
      orderAppealObj: []
    };
  },
  computed: {
    showPass() {
      let state =
        this.form.loadQuantity == this.copyForm.loadQuantity &&
        this.form.unloadQuantity == this.copyForm.unloadQuantity &&
        this.form.abnormalFee == this.copyForm.abnormalFee &&
        this.form.extraFee == this.copyForm.extraFee;
      console.log("是否通过=================", state);
      return state;
    },
    ticketImageUrls() {
      return this.form.ticketImageUrls.filter(item => item);
    },
    loadImgUrls() {
      return this.form.loadImgUrls.filter(item => item);
    }
  },
  async created() {},
  methods: {
    handlePass() {
      const rLoading = this.openLoading();
      orderHandlePC({ codes: this.preservation.code }).then(response => {
        rLoading.close();
        this.$message({
          message: response.data,
          type: "success"
        });
        this.funcCancel();
      });
    },
    funcReject() {
      this.$emit("funcReject", this.preservation.code);
    },
    uploadClick() {
      this.$emit("openMap", this.preservation.code, this.form);
    },
    getExtraFeeTypeDict(branchCode) {
      getListDict({ types: "extraFeeType", branchCode: branchCode }).then(
        response => {
          this.extraFeeType = response.data[0].dictList;
        }
      );
    },
    checkLength(value, index) {
      if (value) {
        if (value.length > 255) {
          this.$message({
            message: "备注最长为255个字符，请检查第" + (index + 1) + "行",
            type: "warning"
          });
          return false;
        }
      }
    },
    setDelivery(val) {
      this.form.deliveryCashFee =
        Number(val) + Number(this.form.platformPrepayment) || 0;
    },
    // 设置货物数量
    setWeight(value, key, name) {
      if (name == "件") {
        this.$set(this.form, key, value.replace(/\.[0-9]+/, ""));
      } else {
        this.$set(
          this.form,
          key,
          value.replace(/([0-9]+\.[0-9]{3})[0-9]*/, "$1")
        );
      }
    },
    saveExtraFee() {
      let sum = 0;
      if (this.orderExtraFeeList && this.orderExtraFeeList.length > 0) {
        for (let i = 0; i < this.orderExtraFeeList.length; i++) {
          const extraFee = this.orderExtraFeeList[i];
          const remark = this.orderExtraFeeList[i].extraFeeRemark;
          if (remark) {
            if (remark.length > 255) {
              this.$message({
                message: "备注最长为255个字符，请检查第" + (i + 1) + "行",
                type: "warning"
              });
              return false;
            }
          }
          if (
            extraFee.extraFeeType &&
            extraFee.extraFeeAmount &&
            extraFee.extraPayType
          ) {
            if (extraFee.extraPayType === "0") {
              sum += parseFloat(extraFee.extraFeeAmount) * 100;
            } else {
              sum -= parseFloat(extraFee.extraFeeAmount) * 100;
            }
          } else {
            this.$message({
              message:
                "费用名称，金额，收支类型为必填项，不能为空，请先检查第" +
                (i + 1) +
                "行",
              type: "warning"
            });
            return false;
          }
        }
      }
      this.form.orderExtraFeeList = JSON.parse(
        JSON.stringify(this.orderExtraFeeList)
      );
      this.form.extraFee = parseFloat(sum / 100);
      this.showEditTable = false;
    },
    backExtraFee() {
      this.showEditTable = false;
      this.orderExtraFeeList = JSON.parse(
        JSON.stringify(this.form.orderExtraFeeList)
      );
    },
    getExtraFeeType(value, row) {
      row.extraFeeName = this.extraFeeType[value];
    },
    insertEvent(rowIndex) {
      const record = {
        extraFeeType: "",
        extraFeeAmount: 0,
        extraPayType: "",
        extraFeeRemark: ""
      };
      this.orderExtraFeeList.splice(rowIndex + 1, 0, record);
    },
    delRowEvent(row, rowIndex) {
      this.$confirm("确认刪除吗？").then(_ => {
        this.orderExtraFeeList.splice(rowIndex, 1);
      });
    },
    queryOrderAppealListApi(code) {
      queryOrderAppealList({
        orderCode: code
      }).then(response => {
        console.log("申诉列表", response);
        if (response.data && response.data.records) {
          this.orderAppealObj = response.data.records;
        }
      });
    },
    shipmentlist(c, row) {
      this.form = Object.assign({}, this.emptyForm);
      this.step = 1;
      this.preservation.code = c;
      this.authorizeCause = row.authorizeCause;
      this.queryOrderAppealListApi(c);
      this.orderExtraFeeList = [];
      calculateOrderDetail(this.preservation).then(response => {
        this.form = response.data;
        this.copyForm = JSON.parse(JSON.stringify(this.form));
        if (!this.form.orderExtraFeeList) this.form.orderExtraFeeList = [];
        if (this.form.orderExtraFeeList.length > 0) {
          for (const i in this.form.orderExtraFeeList) {
            this.form.orderExtraFeeList[i].extraPayType =
              this.form.orderExtraFeeList[i].extraPayType + "";
          }
          this.orderExtraFeeList = JSON.parse(
            JSON.stringify(this.form.orderExtraFeeList)
          );
        }
        this.getExtraFeeTypeDict(response.data.branchCode);
      });
    },
    detailsbut(form) {
      if (this.submitDisabled) {
        this.$message({
          message: "重新计算中，请稍等！",
          type: "success"
        });
        return false;
      }
      this.$refs[form].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const params = JSON.parse(JSON.stringify(this.form));
          params.orderExtraFeeListStr = JSON.stringify(
            params.orderExtraFeeList
          );
          delete params.orderExtraFeeList;
          orderHandleEditSubmit(params).then(response => {
            rLoading.close();
            this.$message({
              message: response.data,
              type: "success"
            });
            this.$emit("event2");
          });
        } else {
          return false;
        }
      });
    },
    detailsSave(form) {
      if (this.submitDisabled) {
        this.$message({
          message: "重新计算中，请稍等！",
          type: "success"
        });
        return false;
      }
      this.$refs[form].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          let code = this.preservation.code;
          const params = JSON.parse(JSON.stringify(this.form));
          params.orderExtraFeeListStr = JSON.stringify(
            params.orderExtraFeeList
          );
          delete params.orderExtraFeeList;
          let data = {
            codes: [code],
            status: 1,
            data: params
          };
          reviewAppeal(data).then(response => {
            rLoading.close();
            this.$message({
              message: response.msg,
              type: "success"
            });
            this.$emit("event2");
          });
          // const params = JSON.parse(JSON.stringify(this.form));
          // params.orderExtraFeeListStr = JSON.stringify(
          //   params.orderExtraFeeList
          // );
          // delete params.orderExtraFeeList;
          // orderHandleEditSubmitAndSave(params).then(response => {
          //   rLoading.close();
          //   this.$message({
          //     message: response.data,
          //     type: "success"
          //   });
          //   this.$emit("event2");
          // });
        } else {
          return false;
        }
      });
    },
    search(step) {
      this.submitDisabled = true;
      let message = this.$message({
        message: "计算中,请稍等!",
        type: "success"
      });
      const params = JSON.parse(JSON.stringify(this.form));
      if (
        !isNumber(params.loadQuantity) ||
        !isNumber(params.unloadQuantity) ||
        !isNumber(params.abnormalFee)
      ) {
        this.submitDisabled = false;
        return;
      }
      params.orderExtraFeeListStr = JSON.stringify(params.orderExtraFeeList);
      delete params.orderExtraFeeList;
      calculateOrderDetail(params)
        .then(response => {
          this.form = response.data;
          if (!this.form.orderExtraFeeList) this.form.orderExtraFeeList = [];
          if (this.form.orderExtraFeeList.length > 0) {
            for (const i in this.form.orderExtraFeeList) {
              this.form.orderExtraFeeList[i].extraPayType =
                this.form.orderExtraFeeList[i].extraPayType + "";
            }
          }
          this.step = step;
        })
        .finally(() => {
          message.close();
          this.submitDisabled = false;
        });
    },
    handleStep(step, form) {
      if (step == 2) {
        // 下一步
        this.$refs[form].validate(valid => {
          if (valid) {
            // 计算
            this.form1 = Object.assign({}, this.form);
            this.search(step);
          }
        });
      } else if (step == 1) {
        // 上一步
        this.from = Object.assign({}, this.form1);
        this.$set(this.form, "driverActualCash", this.from.driverActualCash);
        this.step = step;
      }
    },
    funcCancel() {
      this.$emit("handleCancel");
    }
  }
};
</script>

<style lang="scss" scoped>
.orderAppealObj_text {
  margin-bottom: 15px;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 5px;
}
.orderAppealObj_img_box {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  margin-left: 10px;
  border-radius: 5px;
}
.titleh1 {
  line-height: 50px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 15px;
  code {
    width: 5px;
    height: 20px;
    background-color: #ff7f21;
    float: left;
    margin-right: 5px;
    margin-top: 13px;
  }
}
.el-autocomplete {
  width: 81%;
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
</style>
<style></style>
